import { ButtonHTMLAttributes } from 'react'
import styled from 'styled-components'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
}

export const Button = styled.button<ButtonProps>`
    cursor: pointer;
    position: relative;
    outline: none;
    border: none;
    text-align: center;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #003b5c;
    color: #fff;
    border-radius: 0px;
    text-transform: uppercase;
    font-family: "Medium";
    font-size: 17px;
    height: 49px;

    &:disabled {
        cursor: not-allowed;
        pointer-events: none;
        background-color: #cecece;
    }

    &.right-element {
        position: absolute;
        right: 0;
        top: 0;
        width: 42px;
        height:100%;
        background-color: transparent;
        z-index: 2;

        &.sm {
            height: 50px;
        }
    }
`

export const LButton = styled.button<ButtonProps>`
    font-family: "Linear-Bold";
    background-color:  #3C7B35;
    cursor: pointer;
    position: relative;
    outline: none;
    border: none;
    text-align: center;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 44px;
    border-radius: 22px;
    padding-top: 10px;
    padding-right: 16px;
    padding-bottom: 10px;
    padding-left: 16px;
    gap: 8px;
    color: #fff;
    font-weight: 900;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;
    text-transform: uppercase;
`

export const PaddedButton = styled(Button)`
    padding-left: 2.5rem;
    padding-right: 2.5rem;
`


export const LPaddedButton = styled(LButton)`
    padding-left: 2.5rem;
    padding-right: 2.5rem;
`

export const PageActionButton = styled(PaddedButton)`
    min-width: 130px;

    &.light {
        background-color: #3079c9;
    }

    &.bold-txt {
        font-weight: bold;
        letter-spacing: 0.5px;
    }
`

export const LPageActionButton = styled(LPaddedButton)`
    min-width: 130px;
`

export const CaiButton = styled(PaddedButton)`
    font-family: "Bold";
    font-size: 13px;
    text-align: center;
    background-color: #fff;
    color: #3079c9;
    border: 1px solid #3079c9;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    height: 37px;
    min-height: 37px;

    &.solid-btn {
        color: #fff;
        background-color: #3079c9;
        letter-spacing: 1px;
    }

    &.with-icon {
        svg {
            margin-right: 8px;
            font-size: 18px;
        }
    }
`

export const CaiCameraButton = styled(CaiButton)`
  min-height: 49px;
  min-width: 230px;
  font-size: 16px;

  label {
    margin-top: 3px;
  }

  &.is-in-file-list {
    box-sizing: border-box;
    background-color: #3079C933;
    border: none;
    min-height: unset;
    min-width: unset;
    width: 134px;
    height: 130px;
    border-radius: 16px;
  }
`

export const AddCameraBtnContainer = styled.div`
    cursor: pointer;
    &.is-in-file-list {
        align-self: start;
    }
`


interface InvertedNextButtonProps {
    inverted?: boolean;
}

export const NextButton = styled(PageActionButton)``

export const LNextButton = styled(LButton) <InvertedNextButtonProps>`

    color: ${(props) => (props.inverted === true && '#3C7B35')};
    background-color: ${(props) => (props.inverted === true && 'transparent')};
    border: ${(props) => (props.inverted === true && '2px solid #3C7B35')};
    font-family: ${(props) => (props.inverted === true && 'Linear-Black')};
    max-width: 500px;

    &:disabled {
        cursor: not-allowed;
        pointer-events: none;
        background-color:#BCE0B8;
    }
`

export const LInvertedButton = styled(LButton)`
    border-color:  #3C7B35;
    background-color: transparent;
    color:  #3C7B35;
    height: 40px;
    border-radius: 40px;
    border: 2px solid #3C7B35;
    margin: auto;
    width: unset;
`

export const ShareButton = styled(Button)`
    position: absolute;
    bottom: 0;
    right: 2rem;
    background-color: #3079c9;
    height: 60px;
    width: 60px;
    transform: rotate(45deg);

    svg {
        font-size: 30px;
        transform: rotate(-45deg);
    }
`

export const BackButton = styled(Button)`
    position: relative;
    width: 50px;
    height: 52px;
    background-color: transparent;
    border-right: 1px solid #cecece;

    svg {
        z-index: 101;
        font-size: 20px;
        color: #0f3250;
    }
`

export const CloseButton = styled(Button)`
    position: absolute;
    top: 8px;
    right: 0px;
    width: 30px;
    height: 30px;
    background-color: transparent;
    border: 0px;

    svg {
        z-index: 101;
        font-size: 20px;
        color: #0f3250;
    }
`


interface SecondChoiseButtonProps {
    linear?: boolean;
    disabled?: boolean;
}

export const SecondChoiseButton = styled.button<SecondChoiseButtonProps>`
  cursor: pointer;
  font-family: ${(props) => (props.linear === true ? 'Linear-Bold' : 'Medium')};
  color: ${(props) => (props.linear === true ? '#3C7B35' : '#535353')};
  font-size: ${(props) => (props.linear === true ? '16px' : '14px')};
  position: relative;
  outline: none;
  border: none;
  text-align: center;
  padding-bottom: 0.05rem;
  background: none;
  line-height: 18px;
  display: inline-block;
  text-decoration: ${(props) => (props.linear === true ? 'none' : 'underline')};
  
    &:disabled {
        cursor: not-allowed;
        pointer-events: none;
        opacity: 0.6;
    }
`;

export const TransparentButton = styled(Button)`
    background-color: transparent;
    color: #003b5c;
`

export const TransparentButtonB = styled(TransparentButton)`
    color: #3079c9;
`
